<template>
  <div class="min-h-screen py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-3xl mx-auto bg-gradient-to-b from-purple-900 via-slate-900 to-slate-800 rounded-lg shadow-xl p-8">
      <h1 class="text-3xl font-bold text-slate-200 mb-8 text-center">Contact Us</h1>
      
      <div class="mb-12 text-center">
        <p class="text-slate-300 mb-4">
          Have questions or feedback? We'd love to hear from you.
        </p>
      </div>

      <form @submit.prevent="handleSubmit" class="space-y-6">
        <div>
          <label for="name" class="block text-sm font-medium text-slate-300">Name</label>
          <input 
            type="text" 
            id="name" 
            v-model="formData.name"
            class="mt-1 block w-full rounded-md bg-gray-700 border-gray-600 text-slate-200 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            required
          >
        </div>

        <div>
          <label for="email" class="block text-sm font-medium text-slate-300">Email</label>
          <input 
            type="email" 
            id="email" 
            v-model="formData.email"
            class="mt-1 block w-full rounded-md bg-gray-700 border-gray-600 text-slate-200 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            required
          >
        </div>

        <div>
          <label for="message" class="block text-sm font-medium text-slate-300">Message</label>
          <textarea 
            id="message" 
            v-model="formData.message"
            rows="4" 
            class="mt-1 block w-full rounded-md bg-gray-700 border-gray-600 text-slate-200 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            required
          ></textarea>
        </div>

        <div class="flex justify-center">
          <button 
            type="submit"
            class="inline-flex items-center px-8 py-4 bg-gradient-to-r from-purple-500 to-purple-700 text-white rounded-lg font-semibold hover:from-purple-600 hover:to-purple-800 transition-all duration-200 shadow-lg hover:shadow-purple-500/25"
          >
            Send Message
          </button>
        </div>
      </form>

      <div v-if="submitStatus" :class="['mt-4 p-4 rounded-md text-center', 
        submitStatus.type === 'success' ? 'bg-green-800 text-green-200' : 'bg-red-800 text-red-200']">
        {{ submitStatus.message }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactPage',
  data() {
    return {
      formData: {
        name: '',
        email: '',
        message: ''
      },
      submitStatus: null
    }
  },
  methods: {
    async handleSubmit() {
      try {
        const response = await fetch('https://formspree.io/f/xbllregj', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.formData)
        });

        if (response.ok) {
          this.submitStatus = {
            type: 'success',
            message: 'Thank you for your message! We will get back to you soon.'
          };
          // Reset form
          this.formData = {
            name: '',
            email: '',
            message: ''
          };
        } else {
          throw new Error('Failed to send message');
        }
      } catch (error) {
        this.submitStatus = {
          type: 'error',
          message: 'Sorry, there was an error sending your message. Please try again.'
        };
      }
    }
  }
}
</script>
